import { NavLink } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="mx-auto max-w-6xl px-4 pb-10 pt-4">
      <div className="flex items-center justify-center gap-4 border-t border-line pt-4 text-center text-xs text-muted">
        <NavLink to="/privacy" className="hover:text-fg-2">
          Privacy Policy
        </NavLink>
        <NavLink to="/terms" className="hover:text-fg-2">
          Terms of Service
        </NavLink>
      </div>
    </footer>
  );
}
